/* eslint-disable react/react-in-jsx-scope */
import { Avatar, Button, CardContent, Grid, Typography, makeStyles } from "@material-ui/core";
import { COLORS } from "constants/colors";
import { truncate } from "lodash";
import { VehiculesTypeIcon } from "utils";
import { CourseIcon } from "icons";
import styled from "styled-components";
import { Course } from "generated/graphql";
import CourseCard from "./CourseCard";

export const styles = makeStyles({
  divContainer: {
    width: "32vw",
    padding: "25px 10px",
  },
  drawer: {
    "& .MuiBackdrop-root": {
      backgroundColor: "rgba(0, 0, 0, 0)",
    },
    "& .MuiGrid-item": {
      marginBottom: 10,
    },
  },
  closeIcon: {
    position: "relative",
    cursor: "pointer",
    color: "rgba(117, 122, 147, 1.2)",
  },
  typography: {
    fontSize: "1.5rem",
    fontWeight: 600,
    color: COLORS.secondary,
  },
  gridContainer: {
    display: "flex",
    flexDirection: "row",
    padding: 20,
  },
  iconStyled: {
    justifyContent: "center",
    display: "flex",
    top: -15,
    left: 30,
  },
  labelPickup: {
    color: "#f5b417",
    fontSize: "18px",
    fontWeight: "bold",
  },
  nameStyled: {
    color: COLORS.primary,
    fontSize: "11px",
    alignItems: "center",
    display: "flex",
  },
  gridDisplayed: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: 35,
  },
  action: {
    display: "flex",
    flexDirection: "column",
    "& div > label": {
      color: COLORS.primary,
    },
  },
  buttonStyled: {
    height: "30px",
    backgroundColor: COLORS.accent,
    color: "#fff",
  },
  addressSection: {
    paddingTop: 15,
  },
  vehicleInfo: {
    maxHeight: 30,
  },
  cardInfos: {
    padding: 0,
    width: "90%",
  },
  avatarContainer: {
    display: "flex",
  },
  avatarOne: {
    height: 20,
    width: 20,
  },
  avatarTwo: {
    height: 20,
    width: 20,
    position: "relative",
    zIndex: 1,
    left: -8,
  },
  mainContainer: {
    padding: "0px 15px",
    alignItems: "center",
  },
  subInfo: {
    display: "flex",
    position: "relative",
    bottom: -15,
  },
  actors: {
    marginTop: 2,
    color: "#399ebf",
    fontSize: 12,
  },
  actions: {
    position: "relative",
    right: -15,
  },
  vehicule: {
    display: "flex",
    justifyContent: "space-between",
    position: "relative",
    bottom: -8,
  },
  vehiculeLabel: {
    position: "relative",
    bottom: -8,
    color: "#399ebf",
    fontWeight: "bold",
    fontSize: 10,
  },
  history: {
    color: "#399ebf",
    fontWeight: "bold",
    margin: 20,
  },
  historyContainer: {
    width: "100%",
  },
});

export const StyledCourseIconCard = styled.div.attrs((props) => ({
  color: "",
  ...props,
}))`
  background-color: ${(props) => props?.color || "rgba(57, 158, 191, 0.31)"};
  height: 65px;
  width: 65px;
  border-radius: 19px;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const CourseIconCard = ({ color }: { color: string }) => {
  return (
    <StyledCourseIconCard color={color}>
      <CourseIcon height={30} width={30} />
    </StyledCourseIconCard>
  );
};

export const CourseDetails = ({ course }: { course: Course }) => {
  const classes = styles();
  return (
    <div className={classes.divContainer}>
      <Grid container className={classes.gridContainer} justify="flex-start">
        <Grid container justify="space-between" className={classes.mainContainer}>
          <Grid item xs={3}>
            <CourseIconCard color="#f5b417" />
          </Grid>
          <Grid item xs={7}>
            <div className={classes.labelPickup}>Course</div>
            <div className={classes.subInfo}>
              <div className={classes.avatarContainer}>
                <Avatar className={classes.avatarOne} src={course?.driver?.driver_profile_picture} />
                {course?.conveyor ? (
                  <Avatar className={classes.avatarTwo} src={course?.conveyor?.conveyor_profile_picture} />
                ) : null}
              </div>
              <p className={classes.actors}>
                {truncate(
                  `${course?.driver?.driver_firstname || ""} ${course?.driver?.driver_lastname || "N/A"} ,
                  ${course?.conveyor?.conveyor_firstname || ""} ${course?.conveyor?.conveyor_lastname || ""}`,
                  {
                    length: 50,
                    separator: " ",
                  }
                )}
              </p>
            </div>
          </Grid>
          <Grid item xs={2}>
            <div className={classes.actions}>
              {course?.vehicleType ? (
                <div className={classes.vehicule}>
                  <div>{VehiculesTypeIcon(course.vehicleType, 28)}</div>
                  <small className={classes.vehiculeLabel}>{course.vehicleType}</small>
                </div>
              ) : (
                <small className={classes.vehiculeLabel}>N/A</small>
              )}
            </div>
          </Grid>
        </Grid>

        <CardContent className={classes.cardInfos}>
          <CourseCard course={course} />
        </CardContent>
      </Grid>
    </div>
  );
};
